import { render } from "./payroll-record.vue?vue&type=template&id=0c3e28f5&scoped=true&ts=true"
import script from "./payroll-record.vue?vue&type=script&lang=ts"
export * from "./payroll-record.vue?vue&type=script&lang=ts"

import "./payroll-record.vue?vue&type=style&index=0&id=0c3e28f5&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3e28f5"]])

export default __exports__